import React, { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { addtype, updatetype } from '../redux-toolkit/Slice/typeSlice';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { POST_type, PUT_type } from '../redux-toolkit/ApiEndpoint';

const Addtype = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { title, label, placeholder, Editdata } = location.state || {};

    const typename = useRef();
    const fileInput = useRef();

    // Prefill the input fields if we're editing
    useEffect(() => {
        if (Editdata) {
            typename.current.value = Editdata.typename;
        }
    }, [Editdata]);

    const handleSave = async (e) => {
        e.preventDefault();
        const inputValue = typename.current.value;
        const selectedFile = fileInput.current.files[0];

        const formData = new FormData();
        formData.append('typename', inputValue);
        if (selectedFile) formData.append('image', selectedFile); // Only append image if a file is selected

        if (Editdata) {
            // Update the product type if Editdata exists
            try {
                dispatch(updatetype({
                    endpoint: PUT_type,
                    uuid: Editdata.uuid,
                    payload: formData,
                })).unwrap();
                toast.success('Product Type updated successfully!');
            } catch (error) {
                toast.error(error || 'Failed to update Product Type. Please try again.');
            }
            navigate('/Productstype');
        } else {
            try {
                dispatch(addtype({
                    payload: formData,
                    endpoint: POST_type,
                })).unwrap();
                toast.success('Product Type added successfully!');
                typename.current.value = "";
                fileInput.current.value = null;
            } catch (error) {
                toast.error(error || 'Failed to add Product Type. Please try again.');
            }
            navigate('/Productstype');
        }
    };

    return (
        <section className="page-padding">
            <div className="container-fluid">
                <div className="col-lg-10">
                    <div className="form-wrapper" data-aos="fade-right" data-aos-duration="3000">
                        <h2 className="title">{title || 'Add'} Product Type</h2>
                        <div className="col-12">
                            <hr />
                        </div>
                        <form>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-12 mb-4">
                                    <label htmlFor="InputProductName" className="mb-2">{label}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={placeholder}
                                        ref={typename}
                                    />
                                </div>
                                <div className="col-lg-6 col-md-6 col-12 mb-4">
                                    <label htmlFor="file" className="mb-2">Upload Image</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        ref={fileInput}
                                    />
                                </div>
                                <div className="col-lg-12 d-flex gap-3">
                                    <button
                                        className="btn-grad d-inline-flex align-items-center justify-content-center text-uppercase border border-0"
                                        onClick={handleSave}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Addtype;
